import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
// import vuex from './store'

import mock from './mock'
import './global'
import '@/assets/css/index.scss'


import 'mint-ui/lib/style.css';
import { Swipe, SwipeItem, Picker, Popup} from 'mint-ui';

Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);
Vue.component(Picker.name, Picker);
Vue.component(Popup.name, Popup);
// Vue.component(Indicator.name, Indicator);

mock();


Vue.config.productionTip = false
Vue.prototype.$axios = axios


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})
